function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 177.2h-92.1l-6.9-14.5h99z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.6 261.6l26-11.7-38.6-85.5c0-.5.1-1 .1-1.4v-36.3l26.3 11.3 11.2-26.2-37.8-16.2c-.3-3.2-1-6.3-2-9.4-2.5-7.2-7-13.5-13-18.2 8.1-6.6 13.1-16.3 13.4-28v-.6-.8-.1-.1-1.3c-.7-22.1-17-37-40.6-37-23.3 0-40 15.2-40.7 37V40.1c.1 8.4 3 16.5 8.2 23.1L45 129.7l22.8 17.1 47.4-63.1c9.5.5 17.1 2.8 21.7 6.4 1.8 1.4 3.2 3.2 3.9 5.4.5 1.5.7 3.1.7 4.8v48.4H92.1v28.5h11l.1 12.6-39.5 55.4 23.2 16.6 42.2-59.1c1.7-2.4 2.7-5.4 2.7-8.4l-.1-17h13l37.9 84.3zM115.4 38.5V38c.3-8.4 7.1-9.4 12.2-9.4s11.9 1 12.2 9.4v1.2c-.3 8.4-7.1 9.4-12.2 9.4s-11.9-1-12.2-9.4v-.7zM0 269.3h283.5v14.2H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 163h78v14.2H0z"
})));